import { createAction, handleActions } from "redux-actions";

export const types = {
  fetchDevices: "DEVICES_FETCH",
  fetchDevicesSuccess: "DEVICES_FETCH_SUCCESS",
  fetchDevicesError: "DEVICES_FETCH_ERROR",
  revokeDevice: "DEVICES_REVOKE",
  revokeDeviceSuccess: "DEVICES_REVOKE_SUCCESS",
  revokeDeviceError: "DEVICES_REVOKE_ERROR",
};

export const fetchDevices = createAction(types.fetchDevices);
export const fetchDevicesSuccess = createAction(types.fetchDevicesSuccess);
export const fetchDevicesError = createAction(types.fetchDevicesError);
export const revokeDevice = createAction(types.revokeDevice);
export const revokeDeviceSuccess = createAction(types.revokeDeviceSuccess);
export const revokeDeviceError = createAction(types.revokeDeviceError);

export const INITIAL_STATE = {
  devices: [],
  loading: false,
  revoking: null,
  error: "",
};

export const devicesReducer = handleActions(
  {
    [types.fetchDevices]: (state) => ({
      ...state,
      loading: true,
      error: "",
    }),
    [types.fetchDevicesSuccess]: (state, action) => ({
      ...state,
      devices: action.payload.devices,
      loading: false,
    }),
    [types.fetchDevicesError]: (state, action) => ({
      ...state,
      loading: false,
      error: action.payload.error,
    }),
    [types.revokeDevice]: (state, action) => ({
      ...state,
      revoking: action.payload.deviceId,
    }),
    [types.revokeDeviceSuccess]: (state, action) => ({
      ...state,
      revoking: null,
      devices: state.devices.filter((d) => d.id !== action.payload.deviceId),
    }),
    [types.revokeDeviceError]: (state, action) => ({
      ...state,
      revoking: null,
      error: action.payload.error,
    }),
  },
  INITIAL_STATE,
);
